import { useState } from 'react'
import OutsideClickAlerter from '@components/OutsideClickAlerter/OutsideClickAlerter'
import BidConditionFilter from '@components/BidConditionFilter/BidConditionFilter'

type dropdownType = {
  conditions: { id: number; name: string; damageDescriptionRequired: boolean }[]
  activeConditions: number[]
  handleCondition: (id: number, isChecked: boolean) => void
  fixedHeight?: boolean
}

export default function BidConditionsDropdown({
  conditions,
  activeConditions,
  handleCondition,
  fixedHeight,
}: dropdownType) {
  const [conditionsOpen, setConditionsOpen] = useState<any>(false)

  return (
    <OutsideClickAlerter callback={() => setConditionsOpen(false)}>
      <div className="relative h-9.5">
        <div className="absolute top-0 left-0 mb-4 z-10 bg-white w-full col-span-1">
          <div
            className="text-base leading-5 text-bidfta-gray-dark border border-bidfta-gray-fieldborder
                                            focus:outline-none focus:border-bidfta-blue relative rounded-md bg-white cursor-default pl-4 py-2"
            onClick={() => setConditionsOpen((prevState: any) => !prevState)}
            onKeyDown={(e) =>
              e.key === 'Enter' &&
              setConditionsOpen((prevState: any) => !prevState)
            }
            role="listbox"
            tabIndex={0}
          >
            Condition
            <span className="w-1.5 h-1.5 absolute top-3.5 right-4 transform -rotate-45 border-b-2 border-l-2 border-bidfta-gray-borderdark" />
          </div>
        </div>
        <div
          className={`w-full pt-4 px-7 border border-bidfta-gray-muted relative z-20 bg-white top-9.5 ${
            conditionsOpen ? '' : 'hidden'
          }`}
          style={fixedHeight ? { maxHeight: '250px', overflowY: 'scroll' } : {}}
        >
          {conditions.map((condition: any) => (
            <BidConditionFilter
              key={condition.id || condition}
              condition={condition.name || condition}
              conditionId={condition.id}
              activeConditions={activeConditions}
              handleCondition={handleCondition}
            />
          ))}
        </div>
      </div>
    </OutsideClickAlerter>
  )
}
